(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/play/assets/javascripts/views/package-rows-container.js') >= 0) return;  svs.modules.push('/modules/lotto/components/play/assets/javascripts/views/package-rows-container.js');

'use strict';

svs.lotto.components.play.views.PackageRowsContainer = Marionette.View.extend({
  className: 'numbergames-play-content grid-row padding-xs-h-1 padding-xs-bottom-2 padding-md-bottom-0 padding-md-h-2',
  regions: {
    andraChansenBannerRegion: '#andraChansenBannerRegion',
    sizePickerRegion: '#sizePickerRegion',
    packageRowsRegion: '#packageRowsRegion',
    andraChansenRowRegion: '#andraChansenRowRegion',
    jokerRowRegion: '#jokerRowRegion',
    packageHuxfluxRegion: '#packageHuxfluxRegion'
  },
  template(data) {
    return svs.lotto.components.play.templates.package_rows_container(data);
  },
  onRender() {
    this.showChildView('sizePickerRegion', new svs.numbergames.game.views.SizePicker({
      model: this.model,
      invertButtons: true
    }));
    this.showChildView('packageRowsRegion', new svs.numbergames.game.views.PackageRows({
      model: this.model,
      className: 'package-rows package-rows-lotto grid-row'
    }));
    this.showChildView('andraChansenRowRegion', new svs.lotto.components.play.views.AndraChansenRowBanner({
      model: this.model,
      className: 'andra-chansen-rows-region',
      ballRowOptions: {
        classNames: ['margin-bottom-half']
      }
    }));
    this.showChildView('jokerRowRegion', new svs.numbergames.game.views.JokerRow({
      model: this.model
    }));
    this.showChildView('packageHuxfluxRegion', new svs.numbergames.game.views.PackageHuxfluxButton({
      model: this.model
    }));
  }
});

 })(window);